<template>
  <button 
    @click="toggleLanguage"
    class="flex items-center px-2 py-1 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-200 rounded-md hover:bg-gray-200 transition-colors focus:outline-none focus:ring-1 focus:ring-blue-400"
  >
    {{ currentLanguage === 'ru' ? 'RU' : 'KZ' }}
  </button>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    }
  },
  methods: {
    toggleLanguage() {
      const newLanguage = this.currentLanguage === 'ru' ? 'kk' : 'ru'
      this.changeLanguage(newLanguage)
    },
    
    async changeLanguage(language) {
      try {
        // Обновляем локаль i18n
        this.$i18n.locale = language
        
        // Сохраняем выбор в localStorage
        localStorage.setItem('language', language)
        
        // Отправляем на сервер (опционально)
        // await api.setLanguage(language)
        
        // Показываем уведомление об успешной смене языка
      } catch (error) {
      // Error handled silently
      }
    }
  }
}
</script> 